import {
	overrideKycStatusWithNewFile,
	uploadFile,
} from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { useMutation, UseQueryResult } from '@tanstack/react-query';

interface Props {
	selectedKycId: string | undefined;
	getKYCDataRequest: UseQueryResult;
}

export const useUploadAndApproveFile = ({ selectedKycId, getKYCDataRequest }: Props) => {
	const overrideKycFileWithNewFileMutation = useMutation({
		mutationFn: (fileId: string) =>
			overrideKycStatusWithNewFile({
				kycId: selectedKycId as string,
				body: { fileId },
			}),
		onSuccess: async () => {
			// once the KYC status is overridden, refresh KYC data
			await getKYCDataRequest.refetch();
		},
	});

	// TODO move this to preSigned url upload
	const uploadFileAndApproveMutation = useMutation({
		mutationFn: uploadFile,
		onSuccess: async (payload) => {
			if (!payload?.payload?.id || !selectedKycId) {
				return;
			}

			// trigger approve file request, linking the newly uploaded file to the KYC
			// TODO make one endpoint that does both upload and link+approve
			const linkedFileId = await overrideKycFileWithNewFileMutation.mutateAsync(
				payload.payload.id
			);

			return linkedFileId;
		},
	});

	return {
		uploadFileAndApproveMutation,
	};
};
